import range from 'lodash/range';

export const ELLIPSIS = null;

/** Sets a practical minimum for maxButtons and terminalButtons */
export const MIN_MAX_BUTTONS = 5;
export const MIN_TERMINAL_BUTTONS = 1;

export const getPageNumbers = ({
  activePage,
  maxButtons,
  terminalButtons,
  totalPages,
}: {
  activePage: number;
  maxButtons: number;
  terminalButtons: number;
  totalPages: number;
}): number[] => {
  if (!maxButtons || !terminalButtons) {
    return [];
  }
  const leftTerminalPages = range(1, terminalButtons + 1);
  const rightTerminalPages = range(
    totalPages + 1 - terminalButtons,
    totalPages + 1
  );
  const totalTerminalButtons = terminalButtons * 2;
  const middleButtonsShown = maxButtons - totalTerminalButtons;
  const neighbors = Math.floor(middleButtonsShown / 2);

  if (totalPages > maxButtons) {
    const leftBound = activePage - neighbors;
    const rightBound = activePage + neighbors;
    const afterFirstPage = terminalButtons + 1;
    const beforeLastPage = totalPages - terminalButtons;

    const startPage = leftBound > afterFirstPage ? leftBound : afterFirstPage;
    const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;

    let middlePages = range(startPage, endPage + 1);

    const showLeftEllipsis = startPage > afterFirstPage;
    const showRightEllipsis = endPage < beforeLastPage;

    if (showLeftEllipsis && !showRightEllipsis) {
      const pages = range(endPage + 1 - middleButtonsShown, endPage + 1);
      middlePages = [ELLIPSIS, ...pages];
    } else if (!showLeftEllipsis && showRightEllipsis) {
      const pages = range(startPage, startPage + middleButtonsShown);
      middlePages = [...pages, ELLIPSIS];
    } else if (showLeftEllipsis && showRightEllipsis) {
      middlePages = [ELLIPSIS, ...middlePages, ELLIPSIS];
    }

    return [...leftTerminalPages, ...middlePages, ...rightTerminalPages];
  }

  return range(1, totalPages + 1);
};
